import { Link } from "react-router-dom";
import { PenLine } from "lucide-react";
import { PageHeader } from "@/components/common";

const Option = ({ to, icon: Icon, env, title, text, testid }) => (
  <Link to={to} data-testid={testid} className="surface group flex items-start gap-4 p-6 transition-all hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md">
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full" style={{ background: `hsl(var(${env}) / 0.1)`, color: `hsl(var(${env}))` }}><Icon size={20} /></span>
    <div><p className="font-serif text-2xl">{title}</p><p className="mt-1 text-sm text-slate-500">{text}</p></div>
  </Link>
);

export default function CreateHub() {
  return (
    <div className="mx-auto max-w-2xl" data-testid="create-hub-page">
      <PageHeader title="Create" subtitle="What would you like to share?" />
      <div className="grid gap-4">
        <Option to="/create/post" icon={PenLine} env="--facts" title="A fact" text="Share something factual. Middle checks it against approved sources and shows whether they agree." testid="create-option-post" />
      </div>
    </div>
  );
}
